import _regeneratorRuntime from "/usr/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var api__createArib = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(postId, userInfo, workInfo) {
    var salaryNumber, params, res;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          salaryNumber = Number(workInfo.salary.replace(/,/g, ''));
          params = _objectSpread(_objectSpread(_objectSpread({
            id: postId,
            post_id: postId
          }, userInfo), workInfo), {}, {
            salary: salaryNumber // this overwrites the original salary
          });
          _context.next = 4;
          return fetcher(null, true).post('/finance/create-arib', params);
        case 4:
          res = _context.sent;
          return _context.abrupt("return", res || null);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function api__createArib(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default api__createArib;